import React from 'react'
import useRoute from '../hooks/use-route'
import useScrollToTop from '../hooks/use-scroll-to-top'

const App: React.FunctionComponent = () => {
  // Every screen starts at the top; router navigation otherwise keeps the
  // previous page's scroll offset.
  useScrollToTop()

  // Get route by pathname
  const route = useRoute()

  return <>{route}</>
}

export default App
